var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../base.component';
import { CommonErrorResponse } from '../error.response';
var CommonErrorHandlerModalComponent = /** @class */ (function (_super) {
    __extends(CommonErrorHandlerModalComponent, _super);
    function CommonErrorHandlerModalComponent(modalRef, errorResponse) {
        var _this = _super.call(this) || this;
        _this.modalRef = modalRef;
        _this.errorResponse = errorResponse;
        return _this;
    }
    CommonErrorHandlerModalComponent.prototype.close = function () {
        this.modalRef.close();
    };
    return CommonErrorHandlerModalComponent;
}(BaseComponent));
export { CommonErrorHandlerModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/error.modal/common.error.handler.modal/common.error.handler.modal.component.ts.pre-build-optimizer.js